module.exports = __webpack_public_path__ + "static/media/Component 27 – 1.3df126cb.svg";